import { Swiper } from 'swiper';
import { Navigation, A11y } from 'swiper/modules';
import 'swiper/css';

const sectionNewsSliders = document.querySelectorAll('section.news-slider');

document.addEventListener('DOMContentLoaded', () => {
	sectionNewsSliders.forEach((section) => {
		if (section.querySelector('.swiper-news-slider')) {
			const sectionId = section.getAttribute('id');
			const swiperId = `#${sectionId} .swiper-news-slider`;

			new Swiper(swiperId, {
				watchSlidesProgress: true,
				modules: [Navigation, A11y],
				a11y: true,
				grabCursor: true,
				slidesPerView: 1.15,
				spaceBetween: 24,
				speed: 400,
				keyboard: {
					enabled: true,
				},
				navigation: {
					nextEl: `#${sectionId} .swiper-btn-next`,
					prevEl: `#${sectionId} .swiper-btn-prev`,
				},
				breakpoints: {
					640: {
						slidesPerView: 2.15,
						spaceBetween: 24,
					},
					1024: {
						slidesPerView: 3.15,
						spaceBetween: 32,
					},
				},
			});
		}
	});
});
